import './style.less';
import moment from 'moment-timezone/builds/moment-timezone-with-data-10-year-range';

export default function($log, $timeout, TimeZoneClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;
  vm.activate = activate;

  vm.startDateOptions = {
    minDate: new Date(),
    opened: false
  };
  vm.endDateOptions = {
    opened: false
  };

  vm.startDateDatepickerOptions = {
    minDate: new Date(),
    maxDate: vm.delivery_end_date
  };

  vm.setTimezone = () => {
    vm.ngModel.delivery_location_time_zone_id = vm.timezone;
    vm.setDeliveryStartDate();
    vm.setDeliveryEndDate();
  };

  vm.setDeliveryStartDate = () => {
    if (!vm.delivery_date) {
      return;
    }

    const delivery_date = moment(vm.delivery_date).startOf('day');

    vm.ngModel.delivery_date = moment
      .tz([delivery_date.year(), delivery_date.month(), delivery_date.date()], vm.timezone)
      .add(vm.delivery_hours, 'h')
      .add(vm.delivery_mins, 'm')
      .toDate();

    if (!vm.delivery_end_date) {
      vm.delivery_end_date = vm.delivery_date;
      vm.setDeliveryEndDate();
    }
  };

  vm.setDeliveryStartTime = () => {
    $timeout(() => {
      if (vm.delivery_hours != null && vm.delivery_end_hours == null) {
        vm.delivery_end_hours = vm.delivery_hours;
      }

      if (vm.delivery_mins != null && vm.delivery_end_mins == null) {
        vm.delivery_end_mins = vm.delivery_mins;
      }

      vm.setDeliveryStartDate();
    });
  };

  vm.setDeliveryEndDate = () => {
    if (!vm.delivery_end_date) {
      return;
    }

    const delivery_end_date = moment(vm.delivery_end_date).startOf('day');

    vm.ngModel.delivery_end_date = moment
      .tz([delivery_end_date.year(), delivery_end_date.month(), delivery_end_date.date()], vm.timezone)
      .add(vm.delivery_end_hours, 'h')
      .add(vm.delivery_end_mins, 'm')
      .toDate();

    if (!vm.delivery_date) {
      vm.delivery_date = vm.delivery_end_date;
      vm.setDeliveryStartDate();
    }
  };

  vm.setDeliveryEndTime = () => {
    $timeout(() => {
      if (vm.delivery_end_hours != null && vm.delivery_hours == null) {
        vm.delivery_hours = vm.delivery_end_hours;
      }

      if (vm.delivery_end_mins != null && !vm.delivery_mins == null) {
        vm.delivery_mins = vm.delivery_end_mins;
      }

      vm.setDeliveryEndDate();
    });
  };

  function activate() {
    $log.debug('Location Editor Component Activated');

    vm.ngModel.delivery_location_time_zone_id = vm.ngModel.delivery_location_time_zone_id || moment.tz.guess();
    vm.timezone = vm.ngModel.delivery_location_time_zone_id;

    vm.timezoneList = TimeZoneClass.selectList;

    vm.delivery_date = vm.ngModel.delivery_date && moment.tz(vm.ngModel.delivery_date, vm.timezone).toDate();

    vm.delivery_end_date =
      vm.ngModel.delivery_end_date && moment.tz(vm.ngModel.delivery_end_date, vm.timezone).toDate();

    vm.delivery_hours = vm.ngModel.delivery_date && moment.tz(vm.ngModel.delivery_date, vm.timezone).hour();
    vm.delivery_mins = vm.ngModel.delivery_date && moment.tz(vm.ngModel.delivery_date, vm.timezone).minute();

    vm.delivery_end_hours = vm.ngModel.delivery_end_date && moment.tz(vm.ngModel.delivery_end_date, vm.timezone).hour();
    vm.delivery_end_mins =
      vm.ngModel.delivery_end_date && moment.tz(vm.ngModel.delivery_end_date, vm.timezone).minute();

    vm.loaded = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/dateEditor/controller.js